import { render, staticRenderFns } from "./Why_Us.vue?vue&type=template&id=ec41bbd4&scoped=true&"
import script from "./Why_Us.vue?vue&type=script&lang=js&"
export * from "./Why_Us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec41bbd4",
  null
  
)

export default component.exports